import classes from "./Root.module.scss";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Footer from "../../components/Footer";
import Navigation from "../../components/Navigation";
import Main from "../Main";
import { Suspense, useEffect } from "react";
import Request from "@components/Request";
import Project from "../Project/Project";
import BaseOverlay from "@components/ui/BaseOverlay";
import Job from "../Job";

const Root = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense fallback={<BaseOverlay />}>
      <div className={classes.root}>
        <Navigation />
        <main>
          <Switch>
            <Redirect to="/main" from="/" exact />
            <Route path="/main" component={Main} />
            <Route path="/projects/:projectId" component={Project} />
            <Route path="/jobs" component={Job} />

            <Redirect from="/:notFound" to="/" exact />
          </Switch>
        </main>
        <Request />
        <Footer />
      </div>
    </Suspense>
  );
};

export default Root;
